
import { ConferenceContext } from 'contexts/conference'
import { useFeatureCheck } from 'hooks/useFeatureCheck'
import { FC, useContext, useEffect } from 'react'

const HEIGHT = 135
const WIDTH = 240

export const Camera: FC<Record<string, never>> = ({ }) => {
    const conference = useContext(ConferenceContext)
    const { isFullFeaturedMode } = useFeatureCheck()

    useEffect(() => {
        if (
            conference.status === 'session-joined' &&
            !conference.isVideoMuted && document.querySelector('#self-video-element') !== null
        ) {
            void conference.rtcSession.setVideoMuted(conference.isVideoMuted)
        }
    }, [conference.status])

    if (!isFullFeaturedMode) {
        return (
            <video-player-container>
                <video-player id='self-video-element' height={HEIGHT} width={WIDTH} />
            </video-player-container>
        )

    } else {
        return null
    }
}
